import axios from './axios';
import { Customer } from '../store/config/types';

async function fetchCustomers(shipperId: number): Promise<Customer[] | undefined> {
  const res = await axios.get(`/customers?shipperId=${shipperId}`);
  return res.data.data;
}

export const customersService = { fetchCustomers };
